<script lang="ts">
	import { linkToggle } from '$lib/actions/linkToggle';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { page } from '$app/stores';

	type Link = {
		href: string;
		label: string;
		name: string;
	};

	export let prevLink: Link;
	export let nextLink: Link;
</script>

<div class="px-footer">
	<a
		class="prevNextWrapper"
		class:hidden={!prevLink.href}
		href={prevLink.href}
		use:linkToggle={$page}>
		<Icon clickable icon="left-chevron" color="rgb(107, 114, 120)" size="24" />
		<div class="prevNext">
			<div class="label px-footer-prev-label">
				{prevLink.label}
			</div>
			<div class="collection">
				{prevLink.name}
			</div>
		</div>
	</a>
	<div class="px-divider" />
	<a
		class="prevNextWrapper"
		class:hidden={!nextLink.href}
		href={nextLink.href}
		use:linkToggle={$page}>
		<div class="prevNext px-footer-next-label">
			<div class="label">
				{nextLink.label}
			</div>
			<div class="collection">
				{nextLink.name}
			</div>
		</div>
		<Icon clickable icon="right-chevron" color="rgb(107, 114, 120)" size="24" />
	</a>
</div>

<style>
	a {
		text-decoration: none;
	}

	.px-footer {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: 154px;
		background-color: var(--footerBackgroundColor);
	}

	.px-divider {
		block-size: 100%;
		inline-size: 1px;
		background-color: rgb(0 0 0 / 5%);
	}

	.prevNextWrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 35%;
		inline-size: 50%;
		color: var(--footerFontColor);
		cursor: pointer;
	}

	.prevNext {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 8px;
	}

	.label {
		color: rgb(157 166 177);
		font-size: 1.3rem;
		font-weight: 500;
		text-transform: uppercase;
	}

	.hidden {
		visibility: hidden;
	}

	.collection {
		color: var(--hubAccentColor);
		font-size: 2rem;
		font-weight: 500;
	}

	/* Reversing arrow icons in RTL  */
	:global(#pageContainer[dir='rtl'] .px-footer .px-icon-right-chevron::before) {
		content: '\E801';
	}

	:global(#pageContainer[dir='rtl'] .px-footer .px-icon-left-chevron::before) {
		content: '\E61d';
	}

	@media screen and (max-width: 575px) {
		.px-footer {
			display: none;
		}
	}
</style>
